import React, { useCallback } from 'react';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';
import { feedback } from 'scenes/AIChatbot/sources/feedback';
import { FeedbackDialog } from 'scenes/AIChatbot/components/FeedbackDialog';

import {
  COMMENT,
  CHAT_ID,
  MESSAGE_ID,
  REASONS,
} from 'scenes/AIChatbot/components/FeedbackDialog/constants';
import { feedbackChat as key } from 'scenes/AIChatbot/data/queryKeyFactory';

export const useFeedback = () => {
  const showModal = useScreenModalV2(FeedbackDialog);
  const mutation = useMutation(key(), feedback, {
    errorMessage: (e) => e.message,
    refresh: false,
  });

  const handleAction = useCallback(
    async ({ chatId, messageId }) => {
      const values = await showModal({
        initialValues: {
          [CHAT_ID]: chatId,
          [MESSAGE_ID]: messageId,
          [REASONS]: [],
          [COMMENT]: '',
        },
      });
      if (!values) return;
      await mutation.mutateAsync(values);
    },
    [mutation, showModal]
  );

  return [handleAction, mutation];
};
